<template>
  <v-row align="center">
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>


    <div class="col-md-12 home-box">
      <Grid></Grid>
    </div>
    <div class="col-md-12 home-tabs-body">
    </div>
  </v-row>
</template>

<script>

import Grid from "@/components/zone/Grid";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Clubs",
  components: {
    Grid
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },

  watch: {

  },

  methods: {

  },

};
</script>
